function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.25 8.72A4.92 4.92 0 0012.95 5a5 5 0 00-10 0A4.92 4.92 0 004.7 8.72 8 8 0 000 16a1 1 0 002 0 6 6 0 1112 0 1 1 0 002 0 8 8 0 00-4.75-7.28zM7.95 8a3 3 0 110-6 3 3 0 010 6z",
  fill: "currentColor",
  fillRule: "evenodd"
})));